import { types } from 'mobx-state-tree';

export const Routes = types.model('Routes', {
  name: types.identifier(types.string),
  path: types.string,
  paramValues: types.optional(types.array(types.string), []),

  get url(): string {
    if (this.hasParams) {
      const params = this.params;
      const values = this.paramValues;
      if (params.length === values.length) {
        let paramUrl = this.path;
        for (var i = 0; i < params.length; i++) {
          paramUrl = paramUrl.replace(`:${params[i]}`, values[i]);
        }
        return paramUrl;
      } 
    }
    return this.path;
  },

  get hasParams(): boolean {
    return this.path.indexOf(':') > -1;
  },
  get params(): string[] {
    const params: string[] = [];
    for (let i = 0; i < this.path.length; i++) {
      let currentParamStart = this.path.indexOf(':', i);
      if (currentParamStart > -1) {
        let currentParamEnd = this.path.indexOf('/', currentParamStart);
        currentParamEnd = currentParamEnd !== -1 ? currentParamEnd : this.path.length;
        params.push(this.path.substring(currentParamStart + 1, currentParamEnd));
        i = currentParamEnd;
      } else {
        break;
      }
    }
    return params;
  }
}, {
  setParamValues(params: string[]) {
    this.paramValues.clear();
    this.paramValues.push(...params);
  }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/common/stores/Routes.ts